/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedbackboard1Inputs */



/**
* | output |
* | --- |
* | "Feedback Board" |
*
* @param {Feedbackboard1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const feedbackboard1 = /** @type {((inputs?: Feedbackboard1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedbackboard1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Feedback Board")
	return /** @type {LocalizedString} */ ("Feedback geben")
});
export { feedbackboard1 as "feedbackBoard" }